import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { lang } from 'src/utils';

export const TimeMachineInfo = () => {
  const [activeDaypartName, setActiveDaypartName] = useState('');
  const [activeAssemblyName, setActiveAssemblyName] = useState('');

  const handleTimeMachineInfoChange = () => {
    setActiveDaypartName(localStorage.getItem('timeMachineDaypart') ?? '');
    setActiveAssemblyName(localStorage.getItem('timeMachineAssembly') ?? '');
  };

  useEffect(() => {
    window.addEventListener('timeMachineEvent', handleTimeMachineInfoChange);

    return () => {
      window.removeEventListener(
        'timeMachineEvent',
        handleTimeMachineInfoChange,
      );
    };
  }, []);

  return activeDaypartName && activeAssemblyName ? (
    <Grid container direction="column" padding={2} spacing={2}>
      <Grid item width="100%">
        <Typography variant="subtitle1">{lang.daypart}</Typography>
        <Typography
          variant="body1"
          overflow="hidden"
          textOverflow="ellipsis"
          title={activeDaypartName}>
          {activeDaypartName}
        </Typography>
      </Grid>

      <Grid item width="100%">
        <Typography variant="subtitle1">{lang.assembly}</Typography>
        <Typography
          variant="body1"
          overflow="hidden"
          textOverflow="ellipsis"
          title={activeAssemblyName}>
          {activeAssemblyName}
        </Typography>
      </Grid>
    </Grid>
  ) : null;
};
